import{s}from"../classes/semver.js";const r=s;var a=(s,a)=>new r(s,a).major;export{a as m};
